import React, { PureComponent } from 'react'
import { isMath } from "../../../../utils";
export default class index extends PureComponent {
    state = {
        isShowCity: false,
        domesticName: '',
        textareaVal: '',
    }

    destinationCityFilte = [];

   handleDestinationCity = (event, item) => {
       const { handleChange } =  this.props.config;
        if(event.currentTarget.getAttribute("class")){
          event.currentTarget.removeAttribute("class");
          this.destinationCityFilte.map((val, i) => {
            if(val === item){
                this.destinationCityFilte.splice(i, 1);
            }
          });
        }else{
          if(this.destinationCityFilte.length < 5){
            event.currentTarget.setAttribute("class", 'colLiActive');
            this.destinationCityFilte.push(item);
          }
        }
        handleChange({
            destinationCityFilte: this.destinationCityFilte,
            textareaVal: this.state.textareaVal
        });

        this.setState({
            textareaVal: this.destinationCityFilte.join(',')
        });
        this.forceUpdate();
    };

    destinationCityDomesticOverseas  = () => {
        const {data} = this.props.config;
     
        return data.map((item, index) => {
            return (
                <li
                    key={index}
                    onClick={(e) => this.handleDestinationCity(e, item)}
                >
                    <span style={{width: '100%'}}>{item}</span>
                </li>
            )
        });
      }

    handleShow = () => {
        this.setState({
            isShowCity: !this.state.isShowCity
        }, () => {
        });
    }

    handleTextArea = (event) => {
     const { handleChange } =  this.props.config;
       const nameVal = event.target.value;
       
       this.setState({
        textareaVal: nameVal.trim(),
       }, () => {
        handleChange({
            destinationCityFilte: this.destinationCityFilte,
            textareaVal: this.state.textareaVal
        });

        if(nameVal.trim() === ''){
            this.destinationCityFilte = [];
        }
       });
    }
    
    componentWillUnmount(){
        const { handleChange } =  this.props.config;
        this.setState({
            textareaVal: '',
           }, () => {
            handleChange({
                destinationCityFilte: [],
                textareaVal: ''
            });
           });
    }

    
    render() {
        const { recReSizeReducer, cityHeightVal } = this.props.config
        const { isShowCity, textareaVal } = this.state;


        const {stepsOne} = this.props.config;
        const cityVal = !isShowCity ? 'SHOW All' : 'SHOW LESS';
        const isHeight = recReSizeReducer <= 750 ? 64 : 58;

        const colListCss = isShowCity ? {height: 'auto',  overflow: 'initial'} :  {height: isMath(recReSizeReducer, cityHeightVal),  overflow: 'hidden'}

        /* return  recReSizeReducer <= 750 ? (
            <>
                <div className="row">
                    <div className="col"><span>{stepsOne.destination.domestic.name}</span><i>*</i></div>
                        <div className="col">
                            <ul id="destinationCityDomestic" className="colList" style={colListCss}>
                                {this.destinationCityDomesticOverseas()}
                            </ul>
                            <span className="isShowAll" onClick={this.handleShow}>{cityVal}</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="textareaBox">
                            <textarea 
                                rows="1"
                                cols="1"
                                placeholder={stepsOne.destination.domestic.placeholder}
                                value={textareaVal}
                                onChange={this.handleTextArea}
                            />
                    </div>
                </div>
                {this.destinationCityFilte.length === 0 ?  <div className="row"><span className='error'>{stepsOne.destination.message}</span></div> : (textareaVal ? null : <div className="row"><span className='error'>*{stepsOne.destination.domestic.placeholder}</span></div>)}
               
            </>
        ) : (
            <>
                <div className="row">
                    <div className="col"><span>{stepsOne.destination.domestic.name}</span><i>*</i></div>
                    <div className="col">
                        <ul id="destinationCityDomestic" className="colList">
                            {this.destinationCityDomesticOverseas()}
                        </ul>
                    </div>
                    <div className="col"><span className="isShowAll" onClick={this.handleShow}>{cityVal}</span></div></div>
                    <div className="row">
                        <div className="textareaBox">
                            <textarea 
                                rows="1"
                                cols="1"
                                placeholder={stepsOne.destination.domestic.placeholder}
                                value={textareaVal}
                                onChange={this.handleTextArea}
                            />
                    </div>
                </div>
                {this.destinationCityFilte.length === 0 ?  <div className="row"><span className='error'>{stepsOne.destination.message}</span></div> : (textareaVal ? null : <div className="row"><span className='error'>*{stepsOne.destination.domestic.placeholder}</span></div>)}
               
            </>
        ) */


        return  (
            <>
                <div className="row">
                    <div className="col"><span>{stepsOne.destination.domestic.name}</span><i>*</i></div>
                        <div className="col">
                            <ul id="destinationCityDomestic" className="colList" style={colListCss}>
                                {this.destinationCityDomesticOverseas()}
                            </ul>
                            <span className="isShowAll" onClick={this.handleShow} style={{height: isMath(recReSizeReducer, isHeight)}}>{cityVal}</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="textareaBox">
                            <textarea 
                                rows="1"
                                cols="1"
                                placeholder={stepsOne.destination.domestic.placeholder}
                                value={textareaVal}
                                onChange={this.handleTextArea}
                            />
                    </div>
                </div>
                {/* {this.destinationCityFilte.length === 0 ?  <div className="row"><span className='error'>{stepsOne.destination.message}</span></div> : (textareaVal ? null : <div className="row"><span className='error'>*{stepsOne.destination.domestic.placeholder}</span></div>)} */}
                {this.destinationCityFilte.length === 0 && textareaVal === '' ?  <div className="row"><span className='error'>{stepsOne.destination.message}</span></div> : null}
               
            </>
        )
    }
}
